window.onscroll = function () {
    var navigation = document.getElementById("navigation");
    if (window.scrollY === 0) {
      navigation.classList.remove("scroll-nav");
    } else {
      navigation.classList.add("scroll-nav");
    }
};
